module.exports = __webpack_public_path__ + "img/chuangjianhuodong.81abeab9.png";